var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_941_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.654 16.6974L13.304 9.34744C13.0394 9.08315 12.7106 8.89222 12.35 8.79341C11.9893 8.6946 11.6091 8.69131 11.2468 8.78387L4.53324 10.541C4.07002 10.6594 3.66017 10.9304 3.36977 11.3102C3.07936 11.69 2.92534 12.1565 2.93253 12.6346C2.97414 17.9128 2.01207 23.1507 0.0975265 28.0696C0.00225356 28.3248 -0.0176322 28.602 0.0402389 28.8682C0.09811 29.1345 0.231298 29.3784 0.42393 29.571C0.616563 29.7637 0.860518 29.8969 1.12672 29.9547C1.39293 30.0126 1.67016 29.9927 1.92538 29.8974C6.84468 27.9851 12.0826 27.0252 17.3604 27.0689C17.8384 27.0761 18.305 26.922 18.6848 26.6316C19.0646 26.3412 19.3356 25.9314 19.454 25.4682L21.2175 18.7546C21.3101 18.3923 21.3068 18.0121 21.208 17.6514C21.1092 17.2908 20.9183 16.962 20.654 16.6974ZM13.9961 21.0903C13.4932 21.5932 12.8525 21.9357 12.155 22.0744C11.4575 22.2132 10.7345 22.142 10.0775 21.8698C9.42047 21.5977 8.85888 21.1368 8.46377 20.5455C8.06867 19.9542 7.85778 19.259 7.85778 18.5478C7.85778 17.8366 8.06867 17.1414 8.46377 16.5501C8.85888 15.9588 9.42047 15.4979 10.0775 15.2258C10.7345 14.9536 11.4575 14.8824 12.155 15.0212C12.8525 15.1599 13.4932 15.5024 13.9961 16.0053C14.6693 16.6802 15.0474 17.5945 15.0474 18.5478C15.0474 19.5011 14.6693 20.4154 13.9961 21.0903Z",
    fill: "#02020A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3755 9.21141L20.7887 0.624604C19.9518 -0.212234 18.595 -0.212234 17.7582 0.624604L14.7035 3.6793C13.8667 4.51614 13.8667 5.87292 14.7035 6.70976L23.2903 15.2966C24.1271 16.1334 25.4839 16.1334 26.3208 15.2966L29.3755 12.2419C30.2123 11.405 30.2123 10.0482 29.3755 9.21141Z",
    fill: "#02020A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_941_832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature22);
export default __webpack_public_path__ + "static/media/feature-2-2.e00084f7093c166d710328c0656521d7.svg";
export { ForwardRef as ReactComponent };